import Templates from "../templates";
import ServicesPage from "../organisms/servicesPage";
const Services = () => {
  return (
    <Templates>
      <ServicesPage/>
    </Templates>
  )
}

export default Services;